import React from 'react';

/**
 * La marge de gauche du prompteur : les repères de la slide, en deux à cinq
 * mots — les lignes `:: …` du conducteur (voir `RE_MARGE` dans parseConducteur).
 *
 * On ne la LIT pas, on s'y RACCROCHE : quand on a perdu le fil, ou qu'on veut
 * dire la slide à sa façon, un coup d'œil à gauche donne le squelette sans le
 * texte. Chaque repère est posé EN FACE du paragraphe qu'il résume, pour que
 * l'œil passe de l'un à l'autre sans chercher. Il suit le curseur de lecture :
 * le repère en cours ressort en bleu, ceux déjà passés s'estompent.
 *
 * ⚠️ LE REPÈRE EST EN POSITION ABSOLUE, À GAUCHE DE SON BLOC, et c'est ce qui
 * garde les respirations du conducteur intactes : une vraie grille à deux
 * colonnes enfermerait les marges de chaque paragraphe dans sa cellule, et
 * doublerait tous les espacements (voir la note sur l'enveloppe des blocs dans
 * RenduConducteur). La place de la marge est réservée par le prompteur, qui
 * décale le texte à droite de `LARGEUR_MARGE`.
 */

/** La place réservée à gauche du texte, en em du prompteur, et le filet qui
    sépare la marge du texte. Le repère se cale à `mr-[1.8em]` du bord du
    texte, soit 0,6 em avant ce filet : changer l'un oblige à changer l'autre. */
export const PLACE_MARGE = 'md:ml-[13em] md:pl-[1.2em] md:border-l-2 md:border-slate-200';

/** Le repère en cours : le dernier dont le bloc est atteint par le curseur. */
export function repereCourant(notes, curseur) {
    let courant = -1;
    if (curseur) notes.forEach((n, i) => { if (n.bloc <= curseur.bloc) courant = i; });
    return courant;
}

/**
 * Les repères d'un bloc. Sur un écran étroit, ils passent au-dessus du
 * paragraphe, en petit.
 *
 * @param notes    `[{texte, i}]` — `i` = rang du repère dans la section
 * @param courant  rang du repère en cours, -1 sans curseur
 */
export default function MargeConducteur({ notes = [], courant = -1 }) {
    if (!notes.length) return null;
    return (
        <div className="md:absolute md:right-full md:top-0 md:w-[11.2em] md:mr-[1.8em] md:text-right md:pt-[0.12em] mt-[0.4em] md:mt-0">
            {notes.map((n) => {
                const etat = n.i === courant ? 'courant' : n.i < courant ? 'passe' : 'avenir';
                return (
                    <div
                        key={n.i}
                        className={`text-[0.92em] leading-snug transition-colors duration-300 ${etat === 'courant'
                            ? 'text-sky-700 font-bold'
                            : etat === 'passe'
                                ? 'text-slate-400 font-semibold'
                                : 'text-slate-700 font-semibold'
                            }`}
                    >
                        {n.texte}
                    </div>
                );
            })}
        </div>
    );
}
